import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cs-shell"
  }, [_c("aside", {
    staticClass: "cs-session-pane"
  }, [_c("div", {
    staticClass: "cs-pane-header"
  }, [_c("div", [_c("div", {
    staticClass: "cs-pane-title"
  }, [_vm._v("网页咨询")]), _c("div", {
    staticClass: "cs-pane-subtitle"
  }, [_vm._v(_vm._s(_vm.sessions.length) + " 个活跃会话")])]), _c("el-button", {
    attrs: {
      type: "text",
      size: "mini"
    },
    on: {
      click: _vm.loadSessions
    }
  }, [_vm._v("刷新")])], 1), _c("div", {
    staticClass: "cs-session-list"
  }, _vm._l(_vm.sessions, function (session) {
    return _c("div", {
      key: session.sessionId,
      staticClass: "cs-session-item",
      class: {
        active: _vm.selectedSession && _vm.selectedSession.sessionId === session.sessionId
      },
      on: {
        click: function click($event) {
          return _vm.selectSession(session);
        }
      }
    }, [_c("div", {
      staticClass: "cs-session-avatar"
    }, [_vm._v(" " + _vm._s(_vm.getAvatarText(session.customerName || "访")) + " ")]), _c("div", {
      staticClass: "cs-session-main"
    }, [_c("div", {
      staticClass: "cs-session-title"
    }, [_c("span", [_vm._v(_vm._s(session.customerName || "匿名客户"))]), _c("span", {
      staticClass: "cs-session-time"
    }, [_vm._v(_vm._s(_vm.formatTime(session.lastMessageTime)))])]), _c("div", {
      staticClass: "cs-session-meta"
    }, [_c("span", [_vm._v(_vm._s(session.websiteDomain || "网页访客"))]), _c("span", [_vm._v(_vm._s(_vm.formatSessionId(session.sessionId)))])]), _c("div", {
      staticClass: "cs-session-last"
    }, [_vm._v(_vm._s(session.lastMessage || "暂无消息"))])]), _c("el-badge", {
      staticClass: "cs-session-badge",
      attrs: {
        value: session.unreadCount,
        hidden: !session.unreadCount,
        max: 99
      }
    })], 1);
  }), 0)]), _c("section", {
    staticClass: "cs-chat-pane"
  }, [_vm.selectedSession ? [_c("div", {
    staticClass: "cs-chat-header"
  }, [_c("div", {
    staticClass: "cs-chat-profile"
  }, [_c("div", {
    staticClass: "cs-chat-avatar"
  }, [_vm._v(_vm._s(_vm.getAvatarText(_vm.selectedSession.customerName || "访")))]), _c("div", [_c("div", {
    staticClass: "cs-chat-title"
  }, [_vm._v(_vm._s(_vm.selectedSession.customerName || "匿名客户"))]), _c("div", {
    staticClass: "cs-chat-subtitle"
  }, [_vm._v(" " + _vm._s(_vm.selectedSession.websiteDomain || "网页访客") + " / " + _vm._s(_vm.formatSessionId(_vm.selectedSession.sessionId)) + " ")])])]), _c("div", {
    staticClass: "cs-chat-actions"
  }, [_c("el-tag", {
    attrs: {
      size: "mini",
      type: "success"
    }
  }, [_vm._v(_vm._s(_vm.getSessionStatusText(_vm.selectedSession.sessionStatus)))]), _c("el-button", {
    attrs: {
      type: "danger",
      size: "mini",
      plain: ""
    },
    on: {
      click: _vm.endCurrentSession
    }
  }, [_vm._v("结束")])], 1)]), _c("div", {
    ref: "messageList",
    staticClass: "cs-message-list"
  }, _vm._l(_vm.messages, function (message) {
    return _c("div", {
      key: message.messageId || message.id || "".concat(message.createdTime, "-").concat(message.content),
      staticClass: "cs-message-row",
      class: _vm.getMessageClass(message.senderType)
    }, [Number(message.senderType) === 4 ? [_c("div", {
      staticClass: "cs-system-message"
    }, [_vm._v(_vm._s(message.content))])] : [_c("div", {
      staticClass: "cs-message-avatar"
    }, [_vm._v(_vm._s(_vm.getMessageAvatar(message)))]), _c("div", {
      staticClass: "cs-message-stack"
    }, [_c("div", {
      staticClass: "cs-message-name"
    }, [_vm._v(_vm._s(message.senderName || _vm.getSenderName(message.senderType)))]), _c("div", {
      staticClass: "cs-message-bubble"
    }, [_vm.isAudioMessage(message) ? _c("div", {
      staticClass: "cs-audio-content"
    }, [_vm.getAudioAttachment(message).url ? _c("button", {
      staticClass: "cs-audio-play",
      class: {
        playing: _vm.playingAudioMessageId === message.messageId
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.toggleAudioPlayback(message);
        }
      }
    }, [_c("i", {
      class: _vm.playingAudioMessageId === message.messageId ? "el-icon-video-pause" : "el-icon-video-play"
    }), _c("span", [_vm._v(_vm._s(_vm.playingAudioMessageId === message.messageId ? "暂停语音" : "播放语音"))])]) : _c("div", {
      staticClass: "cs-audio-missing"
    }, [_vm._v("语音文件不可用")]), _c("div", {
      staticClass: "cs-audio-meta"
    }, [_c("span", [_vm._v(_vm._s(_vm.getAudioDurationText(message)))])])]) : _c("div", {
      staticClass: "cs-message-content"
    }, [_vm._v(_vm._s(message.content))])]), _c("div", {
      staticClass: "cs-message-time"
    }, [_vm._v(_vm._s(_vm.formatTime(message.createdTime)))])])]], 2);
  }), 0), _c("div", {
    staticClass: "cs-reply-box"
  }, [_c("div", {
    staticClass: "cs-reply-toolbar"
  }, [_c("span", [_vm._v("回复给 " + _vm._s(_vm.selectedSession.customerName || "匿名客户"))]), _c("span", [_vm._v("Enter 发送 / Ctrl+Enter 换行")])]), _c("div", {
    staticClass: "cs-reply-templates"
  }, [_c("div", {
    staticClass: "cs-template-tabs"
  }, [_c("span", {
    staticClass: "cs-template-label"
  }, [_vm._v("话术")]), _vm._l(_vm.quickReplyCategories, function (category) {
    return _c("button", {
      key: category.key,
      staticClass: "cs-template-tab",
      class: {
        active: _vm.activeQuickReplyCategory === category.key
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          _vm.activeQuickReplyCategory = category.key;
        }
      }
    }, [_vm._v(" " + _vm._s(category.name) + " ")]);
  })], 2), _c("div", {
    staticClass: "cs-template-list"
  }, _vm._l(_vm.activeQuickReplies, function (template) {
    return _c("button", {
      key: template.id || template.content,
      staticClass: "cs-template-chip",
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.insertQuickReply(template);
        }
      }
    }, [_vm._v(" " + _vm._s(template.title || template.content) + " ")]);
  }), 0)]), _c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 2,
        maxRows: 5
      },
      placeholder: "输入回复消息..."
    },
    nativeOn: {
      keydown: function keydown($event) {
        return _vm.handleReplyKeydown.apply(null, arguments);
      }
    },
    model: {
      value: _vm.replyText,
      callback: function callback($$v) {
        _vm.replyText = $$v;
      },
      expression: "replyText"
    }
  }), _c("el-button", {
    attrs: {
      type: "primary",
      size: "small",
      disabled: !_vm.replyText.trim()
    },
    on: {
      click: _vm.sendReply
    }
  }, [_vm._v(" 发送 ")])], 1)] : _c("div", {
    staticClass: "cs-empty"
  }, [_c("i", {
    staticClass: "el-icon-chat-dot-round"
  }), _c("span", [_vm._v("请选择一个网页咨询会话")])])], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };